import { render, staticRenderFns } from "./addDynamic.vue?vue&type=template&id=fd51fd98&scoped=true&"
import script from "./addDynamic.vue?vue&type=script&lang=js&"
export * from "./addDynamic.vue?vue&type=script&lang=js&"
import style0 from "./addDynamic.vue?vue&type=style&index=0&id=fd51fd98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd51fd98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd51fd98')) {
      api.createRecord('fd51fd98', component.options)
    } else {
      api.reload('fd51fd98', component.options)
    }
    module.hot.accept("./addDynamic.vue?vue&type=template&id=fd51fd98&scoped=true&", function () {
      api.rerender('fd51fd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/topManagement/topicTag/components/addDynamic.vue"
export default component.exports